module.exports = __webpack_public_path__ + "img/logo-icon.a4abe258.png";